import React from 'react';
import { Modal } from '../../../Share/components';
import LicenseForm from './LicenseForm';
import PropTypes from 'prop-types';
import { isIE } from '../../../Share/utils';

function CreateLicense({
  isVisible = false,
  onClose = () => {},
  title = 'Teckna licens',
  license = {},
  isEdit = false,
  upgrade = false,
  downgrade = false,
  callBack = () => {},
}) {
  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText={title}
      className="tv-create-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      {isVisible && (
        <LicenseForm
          callBack={callBack}
          onClose={onClose}
          formData={license}
          isEdit={isEdit}
          upgrade={upgrade}
          downgrade={downgrade}
          displayConfirmation={true}
        />
      )}
    </Modal>
  );
}

CreateLicense.prototype = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  license: PropTypes.shape({}),
  title: PropTypes.string,
  isEdit: PropTypes.bool,
  upgrade: PropTypes.bool,
  downgrade: PropTypes.bool,
  callBack: PropTypes.func,
};

export default CreateLicense;
